import React from 'react';
import { func, bool } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel, UTExternalLink } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { ROUTES } from 'constants/routes';
import { appConfig } from 'config/customization';
import Images from 'config/assets';
import { accountPropTypes } from 'redux/accountHandlers';
import { currentUserPropTypes } from 'redux/authHandlers';
import { DefaultViewport } from 'constants/deviceSizes';

import TopbarButton from './components/TopbarButton';
import TopBarDropDown from './components/TopBarDropdown';
import stylesJS from './styles';
import styles from './styles.module.scss';

const Topbar = ({
  clientSummary,
  useClientSummary,
  handleClientSummary,
  handleClientDashboard,
  onSignOut,
  onGoToSignIn,
  currentAccount,
  user,
  handleUtilityLogoClick,
  inMaintenance,
  withoutLogo
}) => {
  const isPublic = !user;
  return (
    <div className={styles.container}>
      {appConfig.topbarUtilityLogo && !withoutLogo ? (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        appConfig.topbar.logoExternalLink ? (
          <UTExternalLink url={appConfig.topbar.logoExternalLink} className={styles.utilityLogo}>
            <img src={Images.topbarLogo} alt="logo" style={stylesJS.utilityLogo} />
          </UTExternalLink>
        ) : (
          <img
            src={Images.topbarLogo}
            style={stylesJS.utilityLogo}
            alt="logo"
            onClick={handleUtilityLogoClick}
          />
        )
      ) : (
        <UTLabel white style={stylesJS.title}>
          {appConfig.appTitle}
        </UTLabel>
      )}
      {useClientSummary && (
        <UTButton
          secondary
          className={`${styles.clientSummary} ${!clientSummary && styles.inactive}`}
          onPress={!clientSummary ? handleClientSummary : handleClientDashboard}
        >
          {message('ClientSummary:clientSummary').toUpperCase()}{' '}
        </UTButton>
      )}
      <div style={stylesJS.actions}>
        {!isPublic && user && (
          <UTLabel white light style={stylesJS.userInfo}>
            {`${user.first_name || ''} ${user.last_name || ''}`}
          </UTLabel>
        )}
        {appConfig.usePoints && (
          <UTLabel white bold style={stylesJS.userInfo}>{`, ${user.total_points || 0} ${message(
            'Points:points'
          )}`}</UTLabel>
        )}
        <DefaultViewport>
          {!isPublic && currentAccount && appConfig.usePoints && (
            <TopbarButton
              icon={Images.topbarPoints}
              hoverIcon={Images.topbarPointsHover}
              route={ROUTES.POINTS}
            />
          )}
        </DefaultViewport>
        {!isPublic && currentAccount && (
          <TopBarDropDown
            icon={Images.topbarAlertOff}
            hoverIcon={Images.topbarAlertOffHover}
            notificationAmount={currentAccount.new_notifications + user.new_notifications}
          />
        )}
        {!isPublic && (
          <DefaultViewport>
            <TopbarButton
              icon={Images.topbarSettings}
              hoverIcon={Images.topbarSettingsHover}
              route={ROUTES.CONFIGURATION}
            />
          </DefaultViewport>
        )}
        {!isPublic && (
          <TopbarButton icon={Images.topbarLogout} hoverIcon={Images.topbarLogoutHover} action={onSignOut} />
        )}
        {isPublic && !inMaintenance && !appConfig.topbar.hideLoginButton && (
          <UTButton alternative onPress={onGoToSignIn} className={styles.signInButton}>
            {message('Translation:enter')}
          </UTButton>
        )}
      </div>
    </div>
  );
};

Topbar.propTypes = {
  onSignOut: func.isRequired,
  handleClientSummary: func.isRequired,
  currentAccount: accountPropTypes,
  user: currentUserPropTypes,
  clientSummary: bool,
  useClientSummary: bool,
  onGoToSignIn: func.isRequired,
  handleClientDashboard: func,
  handleUtilityLogoClick: func,
  inMaintenance: bool,
  withoutLogo: bool
};

export default Radium(Topbar);
